import React from 'react';
import { Col, Form } from 'react-bootstrap';

const isValidValue = value =>
  value !== null && value !== undefined && value !== '';

const EditableField = ({
  label,
  value,
  isEditing,
  isEditable,
  name,
  type = 'text',
  onChange,
  disabled = false,
  options = [],
  displayField,
}) => {
  if (!isEditing || !isEditable) {
    return (
      <Col xs={6} md={4} className="mb-3">
        <div className="fw-semibold mb-1">{label}</div>
        <div>
          {type === 'select'
            ? (displayField ? value?.[displayField] : value) || '-'
            : isValidValue(value)
            ? value
            : '-'}
        </div>
      </Col>
    );
  }

  return (
    <Col xs={6} md={4} className="mb-3">
      <Form.Group>
        <Form.Label className="fw-semibold mb-1">{label}</Form.Label>
        {type === 'select' ? (
          <Form.Select
            name={name}
            value={value?.id || ''}
            onChange={onChange}
            disabled={disabled}
          >
            <option value="">Select...</option>
            {options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Form.Select>
        ) : (
          <Form.Control
            type={type}
            name={name}
            value={value || ''}
            onChange={onChange}
            disabled={disabled}
          />
        )}
      </Form.Group>
    </Col>
  );
};

export default EditableField;
